import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c141115"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["value", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString($props.label), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("input", {
      type: "text",
      value: $props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('update:modelValue', $event.target.value))),
      placeholder: $props.placeholder,
      disabled: $props.disabled,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => ($setup.emits('focus'))),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.emits('blur')))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2)
  ], 64 /* STABLE_FRAGMENT */))
}